import Service from './axiosClient';

export async function loginAPI(data) {
  const service = new Service();
  service.createAxios();
  const resp = await service.post('login', data);
  return resp.data;
}

export async function changePasswordAPI(data) {
  const service = new Service();
  service.createAxios();
  const resp = await service.post('changePassword', {
    email: data?.email,
    oldPassword: data?.currentPassword,
    newPassword: data?.newPassword,
  });
  return resp;
}
